import { BASE_URL, GET, INCIDENT_LIST } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchIncidentDetail = async (requestId) => {
  const token = await getAccessToken();
  const url = `${BASE_URL}${INCIDENT_LIST}/${requestId}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};
